import {HttpClient, HttpParams} from "@angular/common/http";
import {ConfigService} from "@docma-mm-core/config/config.service";
import {BasedataService} from "@docma-mm-core/shared/basedata.service";
import {catchError, Observable} from "rxjs";
import {AttributeData} from "@docma-mm-core/attribute/attribute";
import {Injectable} from "@angular/core";

@Injectable()
export class AttributeApiService extends BasedataService {

  private projectUrl = '/projects/';
  private attributeUrl = '/attributes';

  constructor(private http: HttpClient, configService: ConfigService) {
    super(configService);
  }

  private getProjectAttributeUrl(projectId: number) {
    return super.getFullUrl(this.projectUrl + projectId + this.attributeUrl);
  }

  getProjectAttributeList(projectId: number, top: number = 1000, skip: number = 0): Observable<AttributeData> {
    const endpoint = this.getProjectAttributeUrl(projectId);
    let httpParams = new HttpParams();
    if (top) {
      httpParams = httpParams.set('$top', top.toString());
    }
    if (skip) {
      httpParams = httpParams.set('$skip', skip.toString());
    }
    return this.http
      .get<AttributeData>(endpoint, { headers: this.getHeaders(), params: httpParams })
      .pipe(catchError(e  => this.handleError(e)));
  }
}
